import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { user, loading, can } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-slate-900" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!can("data:read")) return <Navigate to="/no-access" replace />;
  return children;
};

export const RequirePerm = ({ perm, children }) => {
  const { can } = useAuth();
  if (!can(perm)) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedRoute;
